module.exports = __webpack_public_path__ + "static/media/retirement-object-4-2.d0e9710c.png";